var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"rounded":"","elevation":"4"}},[_c('v-skeleton-loader',{staticClass:"title",attrs:{"type":"heading, chip"}}),_c('v-skeleton-loader',{staticClass:"text",attrs:{"type":"text@2"}}),_c('v-skeleton-loader',{staticClass:"actions",attrs:{"type":"button@2, button"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }